export default {
  getReportKey: state => id => {
    return state.archiveReports.find(item => item.statReportId === Number(id)).reportKey
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/archive/getters.js